<template>
  <div class="subscription-banner">
    <img
      class="banner-image"
      src="@/assets/img/landing/price/first-subscription-event.png"
      alt="newSubscriptionBanner" />
    <div class="banner-container">
      <div class="left-content">
        <div class="event-badge">
          <v-icon color="primary-light" size="16">mdi-sale</v-icon>
          <span>첫 구독 이벤트</span>
        </div>

        <div class="main-text">
          <p class="question">슈퍼멤버스가 처음이세요?</p>
          <h2 class="offer-title mt-2">
            20% 할인된 가격으로<br />
            3개월 먼저 체험해 보세요!
          </h2>
        </div>

        <button color="default" class="cta-button" @click="handleClickCtaButton">
          <span class="cta-button-text">신규 전용 혜택 받기</span>
        </button>
      </div>

      <div class="right-content">
        <div class="plan-card">
          <div class="plan-header">
            <h3>3개월 플랜</h3>
            <span class="discount-badge">20% 할인</span>
          </div>

          <p class="subtitle mt-1">최소 보장 인원 24명</p>
          <div class="price-section mt-3">
            <div class="price-main">
              <span class="price">12만원</span>
              <span class="unit">/월</span>
              <span class="vat">VAT 별도</span>
              <span class="original-price">150,000원</span>
            </div>
          </div>

          <div class="benefits mt-4">
            <p class="benefit-title">주요 기능</p>
            <ul class="benefit-list">
              <div class="benefit-list-item">
                <li>
                  <v-icon color="#ffd594" size="24">mdi-check</v-icon>
                  <span>블로그 키워드 기초 컨설팅</span>
                </li>
                <li>
                  <v-icon color="#ffd594" size="24">mdi-check</v-icon>
                  <span>블로그 키워드 순위 리포트</span>
                </li>
              </div>
              <div class="benefit-list-item">
                <li>
                  <v-icon color="#ffd594" size="24">mdi-check</v-icon>
                  <span>플레이스 키워드 순위 리포트</span>
                </li>
                <li>
                  <v-icon color="#ffd594" size="24">mdi-check</v-icon>
                  <span>구글 맵 리뷰 제공</span>
                </li>
              </div>
              <div class="benefit-list-item">
                <li>
                  <v-icon color="#ffd594" size="24">mdi-check</v-icon>
                  <span>상위 블로거 무제한 모집</span>
                </li>
                <li>
                  <v-icon color="#ffd594" size="24">mdi-check</v-icon>
                  <span>매장 비공개 한줄평</span>
                </li>
              </div>
            </ul>

            <v-icon color="primary-light" size="24">mdi-plus-circle</v-icon>

            <div class="extra-benefits">
              <div class="extra-list-item">
                <div class="extra-item">
                  <v-icon color="#ffd594" size="24">mdi-check</v-icon>
                  <div class="extra-item-content">
                    <span class="extra-text">블로그 키워드 전략 컨설팅</span>
                    <span class="extra-tag">추가혜택</span>
                  </div>
                </div>
                <div class="extra-item">
                  <v-icon color="#ffd594" size="24">mdi-check</v-icon>
                  <div class="extra-item-content">
                    <span class="extra-text">플레이스 키워드 컨설팅</span>
                    <span class="extra-tag">추가혜택</span>
                  </div>
                </div>
              </div>
              <div class="extra-list-item">
                <div class="extra-item">
                  <v-icon color="#ffd594" size="24">mdi-check</v-icon>
                  <div class="extra-item-content">
                    <span class="extra-text">플레이스 운영 가이드북 제공</span>
                    <span class="extra-tag">추가혜택</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewSubscriptionBanner',
  methods: {
    handleClickCtaButton() {
      this.$emit('click-cta');
    },
  },
};
</script>

<style scoped lang="scss">
.subscription-banner {
  position: relative;
  border-radius: 24px;
  background: #fff0d9;
  padding: 32px 40px;
}

.banner-image {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 529px;
  height: 519px;
}

.banner-container {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.left-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 16px 0px;
  gap: 24px;
  max-width: 420px;
}

.event-badge {
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 4px;
  padding: 8px;
  border-radius: 8px;
  background: rgba(234, 42, 58, 0.05);

  span {
    color: var(--primary-light-color);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
  }
}

.main-text {
  .question {
    color: var(--default-color);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }

  .offer-title {
    color: var(--default-dark-color);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px; /* 128.571% */
  }
}

.cta-button {
  width: fit-content;
  width: 180px;
  padding: 16px;
  border-radius: 12px;
  background: var(--default-color);

  .cta-button-text {
    color: #fff;
    text-align: center;
    font-family: 'Spoqa Han Sans Neo';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
}

.right-content {
  flex: 1;
  backdrop-filter: blur(12px);
}

.plan-card {
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.5);
  padding: 24px;

  .plan-header {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;

    h3 {
      display: inline-block;
      color: var(--default-dark-color);
      font-family: 'Spoqa Han Sans Neo';
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px; /* 150% */
    }

    .discount-badge {
      display: inline-block;
      padding: 2px 8px;
      border-radius: 10px;
      background: var(--tertiary-light-color);

      color: #fff;
      font-family: 'Spoqa Han Sans Neo';
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px; /* 133.333% */
    }
  }
  .subtitle {
    color: var(--default-light-color);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 116.667% */
  }

  .price-section {
    .price-main {
      display: flex;
      align-items: baseline;
      gap: 8px;
      flex-wrap: wrap;

      .price {
        color: var(--default-dark-color);
        font-family: 'Spoqa Han Sans Neo';
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px; /* 133.333% */
      }

      .unit {
        color: var(--default-dark-color);
        font-family: 'Spoqa Han Sans Neo';
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
      }

      .vat {
        color: var(--default-light-color);
        font-family: 'Spoqa Han Sans Neo';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 150% */
      }

      .original-price {
        color: var(--disabled-dark-color);
        font-family: 'Spoqa Han Sans Neo';
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
        text-decoration-line: line-through;
      }
    }
  }

  .benefits {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .benefit-title {
      color: var(--default-color);
      font-family: 'Spoqa Han Sans Neo';
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px; /* 142.857% */
    }

    .benefit-list {
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 16px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0);
      backdrop-filter: blur(5px);

      .benefit-list-item {
        display: flex;
        flex-wrap: wrap;
        row-gap: 16px;
        column-gap: 8px;
      }

      li {
        display: flex;
        align-items: center;
        width: 100%;
        max-width: 276px;
        gap: 8px;

        span {
          color: var(--default-2-color);
          font-family: 'Spoqa Han Sans Neo';
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px; /* 142.857% */
        }
      }
    }

    .extra-benefits {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 16px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0);
      backdrop-filter: blur(5px);

      .extra-list-item {
        display: flex;
        flex-wrap: wrap;
        row-gap: 16px;
        column-gap: 8px;
      }

      .extra-item {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
        max-width: 276px;

        .extra-item-content {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 4px;

          .extra-text {
            color: var(--default-2-color);
            font-family: 'Spoqa Han Sans Neo';
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 142.857% */
          }

          .extra-tag {
            padding: 2px 8px;
            border-radius: 10px;
            background: rgba(234, 42, 58, 0.1);

            color: var(--primary-light-color);
            font-family: 'Spoqa Han Sans Neo';
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px; /* 133.333% */
          }
        }
      }
    }
  }
}
</style>
